import React, { useState } from 'react';
import { ShieldIcon, ChevronDownIcon, ChevronUpIcon } from 'lucide-react';
export function ProofFaqSection() {
  const [openFaq, setOpenFaq] = useState<number | null>(0);
  const faqs = [{
    q: '¿Esto funciona con mentirosos profesionales?',
    a: 'Sí, porque incluso ellos no pueden controlar su sistema nervioso autónomo bajo presión.'
  }, {
    q: '¿Es difícil de aprender?',
    a: 'No, el manual está diseñado para ser leído en menos de una hora y aplicado de inmediato.'
  }, {
    q: '¿Tengo que mirar a la gente de forma extraña?',
    a: 'No, aprenderás a observar de forma periférica y sutil sin que nadie note que los estás decodificando.'
  }, {
    q: '¿Funciona por videollamada?',
    a: 'Sí, el Capítulo 4 se dedica exclusivamente al entorno digital.'
  }];
  return <section className="py-16 md:py-24 bg-slate-900 border-t border-slate-800" data-id="element-248">
      <div className="max-w-4xl mx-auto px-5 md:px-8" data-id="element-249">
        {/* Proof Block */}
        <div className="bg-slate-800/40 border border-brand-900/50 p-8 md:p-10 rounded-2xl mb-20 text-center relative" data-id="element-250">
          <ShieldIcon className="h-12 w-12 text-brand-500 mx-auto mb-6 opacity-80" data-id="element-251" />
          <p className="text-lg md:text-xl text-slate-300 leading-relaxed" data-id="element-252">
            A diferencia de los libros de texto, este método utiliza las mismas
            técnicas de análisis conductual aplicadas en interrogatorios de alta
            presión, simplificadas para que puedas usarlas mañana mismo en una
            cafetería o en una oficina.
          </p>
          <p className="text-lg md:text-xl text-white font-semibold mt-6" data-id="element-253">
            En solo 7 días, tu cerebro empezará a ver "fugas" automáticamente,
            como si estuvieras viendo la realidad en cámara lenta.
          </p>
        </div>

        {/* FAQ Block */}
        <div className="text-center mb-12" data-id="element-254">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-255">
            Preguntas Frecuentes
          </h2>
        </div>

        <div className="space-y-4" data-id="element-256">
          {faqs.map((faq, idx) => <div key={idx} className="bg-slate-800/50 border border-slate-700 rounded-xl overflow-hidden transition-all duration-300" data-id="element-257">
              <button onClick={() => setOpenFaq(openFaq === idx ? null : idx)} className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none" data-id="element-258">
                <span className="font-semibold text-slate-200 pr-4" data-id="element-259">
                  {faq.q}
                </span>
                {openFaq === idx ? <ChevronUpIcon className="h-5 w-5 text-brand-400 flex-shrink-0" data-id="element-260" /> : <ChevronDownIcon className="h-5 w-5 text-slate-500 flex-shrink-0" data-id="element-261" />}
              </button>

              <div className={`px-6 overflow-hidden transition-all duration-300 ease-in-out ${openFaq === idx ? 'max-h-40 pb-5 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-262">
                <p className="text-slate-400" data-id="element-263">{faq.a}</p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}